const Divider = () => <div className={`divider block border-b w-full`}></div>;
export default Divider;